import { AccessLevel } from "@dentally/enums/access-level";
import { JwtPayload } from "jsonwebtoken";

export enum AuthSessionType {
  CONCIERGE = "concierge",
  KIOSK = "kiosk",
  PATIENT = "patient",
}

export type JwtSignOptions = {
  audience: string;
  issuer: string;
};

export type RefreshTokenPayload = {
  type: AuthSessionType;
  practice_id: string;
};
type CommonAuthSessionPayload = {
  access_level: AccessLevel;
  can_login?: boolean | string;
  device_id: string;
  patient_id?: string;
  patient_session_id: string;
  referrer: string;
  restricted_mode?: false;
  sid: string;
  site_id: string;
  uid: string;
  version: "3.0.0";
};

export type AuthSessionPayload = RefreshTokenPayload &
  CommonAuthSessionPayload &
  (
    | {
        access_level: AccessLevel.PUBLIC_IN_PRACTICE;
      }
    | {
        access_level: AccessLevel.PATIENT_IN_PRACTICE | AccessLevel.PATIENT | AccessLevel.PATIENT_UNAUTHENTICATED;
        patient_id: string;
        user_impersonating_patient?: boolean;
        patient_first_name?: string;
      }
  );
export type CompletePayload = AuthSessionPayload & RefreshTokenPayload & JwtPayload;

export type ConciergePatientLoginData = {
  region: string;
  stage: string;
  date_of_birth: string;
  surname_initial: string;
  site_id: string;
  first_name?: string;
};
